import { observer } from 'mobx-react';
import { createElement, FC } from 'react';
import { usePortalMode } from '../hooks/use-portal-mode';
import { PortalMode } from '../stores/portal.store';

export function modeObserver<T extends { mode: PortalMode }>(
    Component: FC<T>
): FC<Omit<T, 'mode'>> {
    return observer(props => {
        const mode = usePortalMode();

        return createElement(Component, { ...props, mode } as any);
    });
}

export function mobileObserver<T extends { mobile: boolean }>(
    Component: FC<T>
): FC<Omit<T, 'mode'>> {
    return observer(props => {
        const mode = usePortalMode();

        return createElement(Component, { ...props, mobile: mode.mobile } as any);
    });
}
